import BaseClient from '@/app/model/api/response/baseApiClient'

class AuthCheckApi extends BaseClient {
  public checkAuth () {
    const path: string = '/v1/auth/check'

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'GET')
  }
}

export default new AuthCheckApi()
